import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import GAlign from "../../../Components/GAlign";
import { data } from "../../../Data/data";
import Img from "../../../assets/images/image";
import BottomBanner from "../../../Components/BottomBanner";
import ButtonComp from "../../../Components/ButtonComp";
import GetQuoteToday from "../../../Components/GetQuoteToday";
import { useRef } from "react";
import AppModal from "../../../Components/AppModal";
import Animation from "../../../animations/Animation";
import styled from "styled-components";
import LightGallery from "../../../Components/LightGallery/LightGallery";

const PortfolioList = () => {
   const modalRef = useRef();
   const [index, setIndex] = React.useState(-1);
   return (
      <section className="pt100 pb100 mobPt50 PobMb50 mobMt10 industryList">
         <Container>
            <Row>
               <Col className="text-center">
                  <h2 className="fBold tabHeadingFontSize mobSubTitle">
                     Our Amazing <span className="colorOrange fBold">Crafts</span>
                  </h2>
                  <p className="fs18">Have a look at some of the inspiring products built for Startups, SMEs and Enterprises.</p>
               </Col>
            </Row>
            <Style>
               <Row className="pt80 mobPt50 text-center">
                  {data.portfolioList.map((portfolio, idx) => (
                     <Col xs={6} sm={6} md={6} lg={6} xl={4} key={portfolio.id} className="card-item my-3">
                        <Animation zoom>
                           <div onClick={() => setIndex(idx)} className="pointer portfolio-card">
                              <img src={portfolio.img} alt={portfolio.title} style={{ width: "100%" }} />
                              <p className="font-20 font-weight-700 text-start d-flex align-items-center px-3" style={{ background: "#EFEFEF", minHeight: "71px", borderRadius: "0px 0px 15px 15px" }}>
                                 {portfolio.title}
                              </p>
                           </div>
                        </Animation>
                     </Col>
                  ))}
               </Row>
               <LightGallery //
                  index={index}
                  list={data.portfolioList}
                  onclose={() => setIndex(-1)}
               />
            </Style>

            <Row className="mt-4">
               <BottomBanner
                  height="446px"
                  extra={
                     <GAlign align="center" mobalign="center">
                        <div className="mt25 ml0">
                           <ButtonComp inputProps={{ onClick: () => modalRef.current?.setModalShow(true) }} title="Get a QUOTE" isDefaultWhite />
                        </div>
                     </GAlign>
                  }
                  title={
                     <>
                        Let's Find a Solution <br />
                        That is Tailor-made for You!
                     </>
                  }
                  description="Our experts are ready to help you. Just send a message and see the magic."
                  image={Img.industrysolution}
               />
            </Row>
         </Container>
         <AppModal ref={modalRef}>
            <GetQuoteToday onModalClose={() => modalRef.current?.setModalShow(false)} />
         </AppModal>
      </section>
   );
};

export default PortfolioList;
const Style = styled.div`
   .card-item-odd:nth-child(2n + 1) {
      margin-top: 128px;
   }
   .card-item-even:nth-child(2n + 2) {
      margin-bottom: 128px;
   }
   .portfolio-card {
      transition: 0.2s;
   }

   .portfolio-card:hover {
      -webkit-box-shadow: 0px 8px 27px -11px rgba(0, 0, 0, 0.57);
      -moz-box-shadow: 0px 8px 27px -11px rgba(0, 0, 0, 0.57);
      box-shadow: 0px 8px 27px -11px rgba(0, 0, 0, 0.57);
      transform: translateY(-8px);
      border-radius: 0px 0px 15px 15px;
   }
`;
